import { PortalPageContent, PortalPageContentHeader } from "@fero/layouts";
import { PurchasersTable } from "./components";

export const PurchasersPage = () => {
  return (
    <PortalPageContent header={<PortalPageContentHeader title="Purchasers" />}>
      <PurchasersTable />
    </PortalPageContent>
  );
};
